import { lockScroll, unlockScroll } from './body-scroll';
// const bodyEl = document.body;
const mainEl = document.querySelector('main');

export const toggleScrollAccessibility = (el, enabled) => {
	if (!el) return;

	if (enabled) {
		lockScroll(el);
		// bodyEl.classList.add('noscroll');
	} else {
		unlockScroll(el);
		// bodyEl.classList.remove('noscroll');
	}
};
export const toggleInert = (enabled) => {
	if (!mainEl) return;

	if (enabled) {
		mainEl.setAttribute('inert', '');
	} else {
		mainEl.removeAttribute('inert');
	}
};
